import {
  OVEntity,
  OVField,
  OVForm,
  OVSearchable,
  OVSidebar,
  OVTable
} from '@ov-suite/ov-metadata';

@OVEntity('StakeholderLocation', 'yardlink')
@OVForm([['#Entry Reason'], ['value']])
@OVSidebar([['id']])
@OVTable<StakeholderLocation>([
  {
    key: 'value',
    title: 'Location',
    type: 'string'
  }
])
export class StakeholderLocation {
  @OVField({
    type: 'string',
    title: 'Unique ID',
    sidebar: true,
    generated: true,
    readonly: true
  })
  id: number;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Location',
    placeholder: 'Required',
    required: true
  })
  value: string;
}
